export default {
  seminar: {
    default: 'Séminaire | Séminaires',
    form: {
      title: 'Demande de séminaire',
      destination: {
        label: 'destination',
        placeholder: 'Où souhaitez-vous aller ?'
      },
      event: {
        label: 'type d\'évènement',
        placeholder: 'Sélectionnez un évènement',
        seminar_training:'Séminaire / Formation',
        conference_congress: 'Colloque / Congrès',
        incentive_trip: 'Voyage incentive',
        event_reception: 'Soirée évènementielle',
        else: 'Autre évènement'
      },
      people: {
        label: 'nombre de personnes',
        placeholder: 'Indiquez le nombre de personnes présentes'
      },
      accomodation: {
        label: 'hébergement'
      },
      bedrooms: {
        label: 'nombre de chambres',
        single: 'simple couchage',
        double: 'double couchage'
      },
      extra: {
        label: 'autres besoins et compléments'
      },
      budget: {
        label: 'budget par personne',
        placeholder: 'Saisissez le montant souhaité'
      },
      request: {
        label: 'réponse souhaitée avant le',
        placeholder: '.. / .. / ....'
      },
      dates: {
        from: 'Date de début',
        to: 'Date de fin'
      }
    }
  }
}
